import styled, {css} from 'styled-components';
import {ReactComponent as Chevron} from '../../assets/icons/chevron.svg'

export const Container = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
`;
const font = css `
  font-family: Poppins;
  font-style: normal;
  color: #151515;
`;
const descFont = css `
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
line-height: 16px;
color: #151515;
`;

const Header = css `
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 32px;
  
`
const iconWrapper = css`
display: flex;
justify-content: center;
align-items: center;
cursor: pointer;

`
const Sections = css`
width:269px;
`
const Style = css`
display: flex;
justify-content: space-between;
`

const Content = css`
display: flex;
flex-direction: column;
justify-content: center;
`
const Auth = css`
display: flex;
width: 116px;
justify-content: space-between;
${descFont}
 margin-top:8px;
`
export const Wrapper = styled.div `
  ${({ header }) => header && Header};
  ${({main})=>main && font};
  ${({icon})=>icon && iconWrapper};
  ${({sections})=>sections && Sections};
  ${({style})=>style && Style};
  ${({content})=>content && Content};
  ${({auth})=>auth && Auth}
`

 const large = css`
 font-weight: 600;
font-size: 18px;
line-height: 27px;
 `
 const medium = css`
font-weight: bold;
font-size: 15px;
line-height: 22px;
 `

export const Title = styled.div `
 ${({header})=>header ? large : medium};
 ${({auth})=>auth && Auth};
`



export const Icon = styled(Chevron)`
margin-left: 6px;
`;


export const Img = styled.img`
`

export  const Tag = styled.div`
font-family: Poppins;
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 18px;
color: #6A983C;
background: #F4F8EC;
border-radius: 12px;
width: 40px;
padding: 0 8px;
margin: 24px 0 8px 0;
`